import * as Sentry from "@sentry/browser";
import { ExtraErrorData as ExtraErrorDataIntegration } from "@sentry/integrations";
import { shouldPolyfill } from "@formatjs/intl-locale/should-polyfill";
if (shouldPolyfill()) {
  import("@formatjs/intl-locale/polyfill");
}
var C = require("./constants.js.erb");

if (C.SENTRY_URL) {
  Sentry.init({
    dsn: C.SENTRY_URL,
    environment: window.RAILS_ENV,
    integrations: [new ExtraErrorDataIntegration()],
    tracesSampleRate: 0.0,
    ignoreErrors: C.SKIP_ERRORS,
    denyUrls: window["C"].SENTRY_DENY_URLS,
    onunhandledrejection: false,
    release: DEFINE_GIT_VERSION,
  });
}

import moment from "moment/moment";
import "moment-timezone";
window["moment"] = moment;
import "angular";
import "core-js/stable";
import "regenerator-runtime/runtime";

require("angular-moment-picker");

import "angular-sanitize";
import "angular-ui-router";
import "angular-animate";
import "oclazyload";

import Dropzone from "./javascripts/lib/dropzone.js";
window["Dropzone"] = Dropzone;
import Papa from "./javascripts/lib/papaparse.js";
window["Papa"] = Papa;
import "angular-loading-bar";
import "angular-debounce";

if (window.caughtStorageException) {
  window.location.assign("/storage_error");
}

var modules = [
  "ui.router",
  "angucomplete-alt",
  "as.sortable",
  "isteven-multi-select",
  "720kb.datepicker",
  "ngAnimate",
  "ngSanitize",
  "ngMask",
  "ngTagsInput",
  "cfp.hotkeys",
  "moment-picker",
  "cfp.loadingBar",
  "rt.debounce",
  "oc.lazyLoad",
  "chart.js",
];

window.tiz = angular.module("tiz", modules);

var templates = require.context("./javascripts/templates/", true, /\.html(\.erb)?$/);
templates.keys().forEach(function (key) {
  templates(key);
});
var svgs = require.context("./javascripts/svelte/Icons", true, /\.svg$/);
svgs.keys().forEach(function (svg) {
  svgs(svg);
});
